
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/formazione/corso/[slug]",
      function () {
        return require("private-next-pages/formazione/corso/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/formazione/corso/[slug]"])
      });
    }
  